import { StringUtil } from './string';
import { GenericInformation } from '../types';
import { ExtendedUserEntity } from '../service/catalog-service/UserEntity';

/**
 * The `UserEntityUtil` is a utility object that provides methods for transforming user entities from Backstage into different formats.
 *
 * @category DataManipulation
 */
export const UserEntityUtil: UserEntityTransformer = {
  toInformationItem: users => {
    return users.map(user => {
      const { email, displayName, picture } = user.spec.profile!;

      return {
        id: user.metadata.uid ?? '',
        primary: displayName ?? '',
        image: picture ?? '/',
        secondary: StringUtil.toTitleCase(user.role.title),
        role: user.role.weight,
        metadata: {
          link: StringUtil.emailToName(email ?? ''),
        },
      };
    });
  },
};

/**
 * `UserEntityTransformer` defines the methods to transform user entities from Backstage into different formats.
 */
export type UserEntityTransformer = {
  /**
   * Transforms the given user entities into information items.
   *
   * @param users - The user entities to be transformed.
   * @returns An array of information items.
   */
  toInformationItem: (users: ExtendedUserEntity[]) => GenericInformation[];
};
